// Debounce utility function
function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const context = this;
        const later = () => {
            clearTimeout(timeout);
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

// Convert base64 string to Blob
function base64ToBlob(base64, mime) {
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let i = 0; i < byteCharacters.length; i++) {
        byteArrays.push(byteCharacters.charCodeAt(i));
    }

    return new Blob([new Uint8Array(byteArrays)], { type: mime });
}

// Max total email size (HTML + base64 images)
const MAX_EMAIL_MB = 10;

export const emailEditorMixin = {
    methods: {
        resizeImage: function(file, maxWidth = 600, callback) {
            const reader = new FileReader();
            reader.onload = function(event) {
                const img = new Image();
                img.onload = function() {
                    let width = img.width;
                    let height = img.height;

                    if (width > maxWidth) {
                        height *= maxWidth / width;
                        width = maxWidth;
                    }

                    const canvas = document.createElement("canvas");
                    canvas.width = width;
                    canvas.height = height;
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0, width, height);

                    canvas.toBlob(function(blob) {
                        callback(blob);
                    }, file.type, 0.85); // 85% JPEG quality
                };
                img.src = event.target.result;
            };
            reader.readAsDataURL(file);
        },

        // Estimate size of base64 images inside content
        estimateEmailSizeMB: function(html) {
            const matches = html.match(/data:image\/[a-zA-Z]+;base64,([^"]+)/g) || [];
            let totalBytes = 0;

            matches.forEach(m => {
                const base64 = m.split(',')[1];
                totalBytes += Math.ceil(base64.length * 3 / 4);
            });

            // HTML text size
            totalBytes += new Blob([html]).size;

            return totalBytes / 1024 / 1024;
        },

        // Debounced size checker
        checkEmailSize: debounce(function(content) {
            const sizeMB = this.estimateEmailSizeMB(content);

            if (sizeMB > MAX_EMAIL_MB) {
                alert(`⚠️ Warning: Your email is approximately ${sizeMB.toFixed(2)} MB.\n\nLarge emails may fail to send.`);
            }
        }, 600),

        // Handle pasted HTML with base64 images
        handlePastedHtmlImages(html, maxWidth = 600, insertTo) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const images = [...doc.querySelectorAll('img[src^="data:image/"]')];

            if (!images.length) {
                window.jQuery(insertTo).summernote('pasteHTML', html);
                return;
            }

            let processedCount = 0;

            images.forEach(img => {
                const dataUrl = img.src;

                // Ignore non-base64 images, defensive check in case browser mutates DOM after parsing
                if (!dataUrl.startsWith("data:image/")) {
                    processedCount++;
                    return;  // skip
                }

                // Extract MIME type
                const mime = dataUrl.substring(
                    dataUrl.indexOf(":") + 1,
                    dataUrl.indexOf(";")
                );

                const base64 = dataUrl.split(",")[1];
                const blob = base64ToBlob(base64, mime);

                // Convert blob to File-like object (name doesn't matter)
                const file = new File([blob], "pasted-image", { type: mime });

                // Use existing resizeImage() function
                this.resizeImage(file, maxWidth, resizedBlob => {
                    const reader = new FileReader();

                    reader.onload = e => {
                        img.src = e.target.result; // put new resized base64 in <img>

                        processedCount++;

                        // Once all <img> are updated → paste final HTML
                        if (processedCount === images.length) {
                            window.jQuery(insertTo).summernote('pasteHTML', doc.body.innerHTML);
                        }
                    };

                    reader.readAsDataURL(resizedBlob);
                });
            });
        }
    }
}